"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_NGINX_URL_LENGTH = exports.ORIGINAL_PROTOCOL_HEADER = exports.ORIGINAL_HOST_HEADER = exports.ORIGINAL_URL_HEADER = exports.SSR_PROTOCOL = exports.SSR_HOST = exports.NO_SCENARIO_FOUND = void 0;
exports.NO_SCENARIO_FOUND = 'NO_SCENARIO_FOUND';
exports.SSR_HOST = 'www.wix.com';
exports.SSR_PROTOCOL = 'http';
exports.ORIGINAL_URL_HEADER = 'x-wix-metro-original-url';
exports.ORIGINAL_HOST_HEADER = 'x-wix-metro-original-host';
exports.ORIGINAL_PROTOCOL_HEADER = 'x-wix-metro-original-protocol';
// Nginx max url length (9kb)
exports.MAX_NGINX_URL_LENGTH = 9216;
//# sourceMappingURL=constants.js.map